// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{
    display: block;
}
.map-container {
    width: 100%;
  height: 100%;
  }
  
  #map-container {
    width: 100%;
    position: relative;
  }

  .search-bar {
    padding: 6px;
    box-sizing: border-box;
    font-size: 16px;
    z-index: 1;
    position: absolute;
    width: 300px;
    margin-left: 190px;
    margin-top: 10px;
  }
  
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImdvb2dsZS1nZW9sb2NhdGlvbi5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksY0FBYztBQUNsQjtBQUNBO0lBQ0ksV0FBVztFQUNiLFlBQVk7RUFDWjs7RUFFQTtJQUNFLFdBQVc7SUFDWCxrQkFBa0I7RUFDcEI7O0VBRUE7SUFDRSxZQUFZO0lBQ1osc0JBQXNCO0lBQ3RCLGVBQWU7SUFDZixVQUFVO0lBQ1Ysa0JBQWtCO0lBQ2xCLFlBQVk7SUFDWixrQkFBa0I7SUFDbEIsZ0JBQWdCO0VBQ2xCIiwiZmlsZSI6Imdvb2dsZS1nZW9sb2NhdGlvbi5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3R7XG4gICAgZGlzcGxheTogYmxvY2s7XG59XG4ubWFwLWNvbnRhaW5lciB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbiAgfVxuICBcbiAgI21hcC1jb250YWluZXIge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgfVxuXG4gIC5zZWFyY2gtYmFyIHtcbiAgICBwYWRkaW5nOiA2cHg7XG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICBmb250LXNpemU6IDE2cHg7XG4gICAgei1pbmRleDogMTtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgd2lkdGg6IDMwMHB4O1xuICAgIG1hcmdpbi1sZWZ0OiAxOTBweDtcbiAgICBtYXJnaW4tdG9wOiAxMHB4O1xuICB9XG4gICJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/google-geolocation/google-geolocation.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,WAAW;EACb,YAAY;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;AAEF,g+BAAg+B","sourcesContent":[":host{\n    display: block;\n}\n.map-container {\n    width: 100%;\n  height: 100%;\n  }\n  \n  #map-container {\n    width: 100%;\n    position: relative;\n  }\n\n  .search-bar {\n    padding: 6px;\n    box-sizing: border-box;\n    font-size: 16px;\n    z-index: 1;\n    position: absolute;\n    width: 300px;\n    margin-left: 190px;\n    margin-top: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
